import { useTranslation } from "react-i18next";
import { Badge, Grid, List, Text, Tooltip, useMantineTheme } from "@mantine/core";
import { IconHome, IconPointFilled } from "@tabler/icons-react";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { FormItem } from "../../../../FormItem";
import { RichTextEditor } from "../../../../RichTextEditor";

export interface AssignmentGeneralDetailProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentGeneralDetail = ({ campaign }: AssignmentGeneralDetailProps) => {
    const { t } = useTranslation(["common"]);

    const theme = useMantineTheme();

    return (
        <>
            <Grid mb="xs">
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem label={t("campaign_name")}>{campaign?.name || <Text color="dimmed">-</Text>}</FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem label={t("campaign_slug")}>{campaign?.slug || <Text color="dimmed">-</Text>}</FormItem>
                </Grid.Col>
            </Grid>
            <Grid mb="xs">
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem mb="xs" label={t("campaign_displaytenants")}>
                        <List>
                            {(campaign?.displayTenants || []).map((tenant, index) => (
                                <List.Item
                                    key={`${index}${tenant?.id}`}
                                    mt="xs"
                                    icon={
                                        campaign?.mainTenant?.id === tenant?.id ? (
                                            <Tooltip
                                                withArrow
                                                label={
                                                    <>
                                                        <Text weight={500}>{t("campaign_maintenant")}</Text>
                                                        <Text>{t("campaign_maintenant_info")}</Text>
                                                    </>
                                                }
                                            >
                                                <IconHome size="1em" color={theme.colors.orange[6]} />
                                            </Tooltip>
                                        ) : (
                                            <IconPointFilled size="1em" />
                                        )
                                    }
                                >
                                    <Text>{tenant?.name || <Text color="dimmed">-</Text>}</Text>
                                    <Text color="dimmed">{tenant?.domainName}</Text>
                                </List.Item>
                            ))}
                        </List>
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem mb="xs" label={t("client")}>
                        {campaign?.client?.name || <Text color="dimmed">-</Text>}
                    </FormItem>
                    <FormItem mb="xs" label={t("campaign_tags")}>
                        {!campaign?.tags?.length && <Text color="dimmed">-</Text>}
                        {(campaign?.tags || []).map((tag, index) => (
                            <Badge key={`${index}${tag?.key || tag?.text}`}>{tag?.text || tag?.key}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
            </Grid>
            <FormItem label={t("campaign_description")}>
                {campaign?.description?.json && (
                    <RichTextEditor value={{ json: campaign.description.json }} readOnly />
                )}
            </FormItem>
        </>
    );
};
